import React from 'react';
import {TextField} from '@material-ui/core'

function RapportName(props) {
    const [Value,setValue] = React.useState("")
    const updateThisName = ()=>{
        props.onUpdate({target:{value:Value}})
    }
    React.useEffect(()=>{setValue(props.Value)},[props.Value])
    return (
        <>
        <TextField 
        variant="outlined" 
        fullWidth
        size="small"
        name="name"
        label=""
        value={Value}
        InputLabelProps={{ shrink: true }}
        onChange={(e)=>{setValue(e.target.value)}}
        onBlur={updateThisName}
        />  
        </>
    );
}

export default RapportName;